import React, {useState} from 'react';
import ContactsForm from "../../components/contactsForm";
import axios from "../../../../helpers/axios";
import sayError from "../../../../helpers/sayError";
import BlockUi from "@availity/block-ui";
import {useNavigate} from "react-router";
import {CounterpartiesContacts} from "../../../routesConstants";
import {Helmet} from "react-helmet";

const tempData={
  "counterparties": [],
  "documents" : [],
  "mileCards" : [],
  "dateOfBirth": "",
  "contacts": [
    {
      "name": "",
      "job": "",
      "description": "",
      "emails": [
      ],
      "phones": [
        {
          "phone": "",
          "comment": ""
        }
      ]
    }
  ]
}
const CreateContacts = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const onSubmit = (data) =>{
    setLoading(true)
    axios.put('/api/counterparty/contacts',data)
      .then(()=>{
        navigate(CounterpartiesContacts)
      })
      .catch(sayError)
      .finally(()=>setLoading(false))
  }
  return (
    <>
      <Helmet>
        <title>Контакт</title>
      </Helmet>
      <BlockUi blocking={loading}>
        <ContactsForm data={tempData} onSubmit={onSubmit}/>
      </BlockUi>
    </>

  );
};

export default CreateContacts;
